import React from "react";

const Ads = () => {
  return (
    <>
      <img
        src="https://s3.amazonaws.com/images.skyscrapercenter.com/thumbs/4929_500x650.jpg"
        className="attachment-full size-full wp-post-image"
        alt=""
        loading="lazy"
        itemprop="image"
        sizes="(max-width: 350px) 100vw, 350px"
        width="180"
        height="925"
      />
    </>
  );
};

export default Ads;
